import React  from 'react'
import { Navigate } from 'react-router-dom';
import {baseurl} from '../config/Settings';
import Header from '../partials/Header';


function Personalize(props) { 

  const lang_translate = require('../language/'+props.lang + '.js');
  
  document.body.classList.add('personalize');
  document.body.classList.add('path-journey');
  document.body.classList.add('path-personalize');
 


   if (!localStorage.getItem('user-info')) {
      return <Navigate to="/" />
  } else {
    return (
      <>
      <Header  skiphref={baseurl} />
      <main>
        <div class="grid-container">
            <div class="personal-wrap get-started">
                <div class="personal-message no-border">
                    <h2>اختر مواضيعك المفضلة لتحصل عليها في صفحة أخباري ​ </h2>
                </div>
                <div class="img-cover">
                    <img src={`${baseurl}themes/custom/aawsatv3/assets/img/personalization/news.svg`} alt="news" />
                </div>
                <div class="action-btn">
                    <a href="#/personalize-author" class="button primary rounded next-btn">ابدأ </a>
                </div>
            </div>
        </div>
    </main>
      </>
    );
  }
}

export default Personalize;
